/* Personalised Street Name Print only: (1) the gallery preview follows the Color circles (it uses the flat artwork for that colour); (2) the Print Border Options swatches (with / without border pictures) become two chips under the finish options, shown only for Fine Art Print and Rolled Canvas (they drive the real Globo radios, so the order data is unchanged; Borderless is picked by default, and any framed finish goes back to Borderless); (3) the colour and border choices are in the enlarged view's Options sheet; (4) choosing White border shows the print inset by 5mm (a white margin all round, scaled to the chosen size) in the gallery preview and enlarged view. */
(function () {
  /* the theme only loads this script on the products it is meant for */
  if (!/\/products\//.test(location.pathname)) return;
  /* the Globo group holding the colour / style choice: the 2nd group on the floppy print (the 1st is the size), the 1st everywhere else */
  var CIN = /floppy-disk/.test(location.pathname) ? 'globo-option-1' : 'globo-option-0';
  document.documentElement.classList.add('fps-on');
  var wst = document.createElement('style');
  wst.textContent = '.fp-zsheet .fp-zpers{display:none!important}';
  document.head.appendChild(wst);
  var st = document.createElement('style');
  st.textContent = '.fps-hide{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important}' +
    '#fps-bo{margin:12px 0 4px}#fps-bo[hidden]{display:none!important}' +
    '#fps-bo .fps-lab{margin:0 0 7px;font-size:13px;font-weight:600;color:#111;letter-spacing:.01em}' +
    '#fps-bo .fps-row{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '#fps-bo .fps-chip{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;gap:10px;width:100%;min-height:64px;padding:8px 10px;border:1.5px solid #d3d6dc;border-radius:12px;background:#fff;color:#222;text-align:left;cursor:pointer;transition:border-color .15s,box-shadow .15s,background .15s}' +
    '#fps-bo .fps-chip:hover{border-color:#9aa0ab}' +
    '#fps-bo .fps-chip.is-selected{border-color:#ff0a89;background:#fff5fa;box-shadow:0 0 0 1px #ff0a89 inset}' +
    '#fps-bo .fps-img{flex:none;width:52px;height:52px;border-radius:8px;object-fit:cover;border:1px solid #d3d6dc;background:#eee}' +
    '#fps-bo .fps-t{display:flex;flex-direction:column;gap:2px;min-width:0}' +
    '#fps-bo .fps-name{font-size:13.5px;line-height:1.2;font-weight:600;color:#111}' +
    '#fps-bo .fps-sub{font-size:12.5px;line-height:1.2;color:#666}';
  document.head.appendChild(st);

  var GBM = { chance: 'version_1', community_chest: 'version_2', electric_company: 'version_3', free_parking: 'version_4', go_to_jail: 'version_5', in_jail: 'version_6', luxury_tax: 'version_7', pass_go: 'version_8', railway_station: 'version_9' };
  var MULTI = /custom-multi-street/.test(location.pathname);
  function key(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''); }
  function colourVal() {
    var rs = document.querySelectorAll('input[name="' + CIN + '"]');
    for (var i = 0; i < rs.length; i++) if (rs[i].checked) return rs[i].value;
    var s = document.querySelector('select[name="options[Color]"]');
    return s ? s.value : '';
  }
  var ping = null;
  function redraw() {
    var pi = document.querySelector('product-info');
    if (!pi) return;
    if (!ping) { ping = document.createElement('span'); ping.hidden = true; pi.appendChild(ping); }
    ping.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function syncStyle() {
    if (MULTI) return;
    var x = window.__fpx, k = key(colourVal());
    if (k && GBM[k]) k = GBM[k];
    k = k.replace(/^card_(\d+)$/, 'version_$1');
    if (!x || !x.s || !k || x.s.style === k) return;
    x.s.style = k;
    redraw();
    setTimeout(zredraw, 220);
  }
  function zredraw() { try { if (window.__fpzoom && window.__fpzoom.redraw) window.__fpzoom.redraw(); } catch (e) { /* ignore */ } }

  function borderEl() {
    var els = document.querySelectorAll('.gpo-element');
    for (var i = 0; i < els.length; i++) {
      var l = els[i].querySelector('.label-content');
      if (l && /^\s*Print Border Options/i.test(l.textContent) && els[i].querySelector('input[type=radio]')) return els[i];
    }
    return null;
  }
  function whiteOn() {
    var el = borderEl(), r = el && el.querySelector('input:checked');
    return !!r && /white border/i.test(r.value);
  }
  /* which finish chip is chosen on the page: fine, rolled, classic, float, box or '' */
  function finish() {
    var c = document.querySelector('.fp-in-panel .fp-chips .fp-opt.is-selected[data-pick^="type:"]');
    return c ? c.getAttribute('data-pick').split(':')[1] : '';
  }
  /* width of the chosen print in mm (the shorter side), from the variant name */
  function mmWidth() {
    try {
      var id = (document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value;
      var v = id && document.querySelector('#fpv-data .fpv-var[data-id="' + id + '"]');
      var t = v ? v.getAttribute('data-t') : '';
      var a = /\bA([0-6])\b/.exec(t);
      if (a) return [841, 594, 420, 297, 210, 148, 105][+a[1]];
      var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/.exec(t);
      if (m) {
        var w = Math.min(+m[1], +m[2]);
        return /\bcm\b/i.test(t) ? w * 10 : w * 25.4;
      }
    } catch (e) { /* ignore */ }
    return 210;
  }
  var padCache = typeof WeakMap === 'function' ? new WeakMap() : null;
  function pad(i) {
    var w = i.naturalWidth || i.width, h = i.naturalHeight || i.height;
    var px = Math.max(2, Math.round(w * 5 / mmWidth()));
    var c = padCache && padCache.get(i);
    if (c && c.px === px) return c.k;
    var k = document.createElement('canvas');
    k.width = w; k.height = h;
    var x = k.getContext('2d');
    x.fillStyle = '#fff';
    x.fillRect(0, 0, w, h);
    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    x.drawImage(i, px, px, w - 2 * px, h - 2 * px);
    var lw = Math.max(2, Math.round(w * 0.0025));
    x.strokeStyle = '#cfd1d6';
    x.lineWidth = lw;
    x.strokeRect(lw / 2, lw / 2, w - lw, h - lw);
    if (padCache) padCache.set(i, { px: px, k: k });
    return k;
  }
  /* The picker keeps the current artwork in one record (window.__fpx.art()); while White border is chosen on a fine art print or rolled canvas its image is swapped for a copy inset by 5mm, and swapped back afterwards. */
  function applyPad() {
    var x = window.__fpx;
    if (!x || typeof x.art !== 'function') return false;
    var t = x.art();
    if (!t || !t.img) return false;
    var f = finish(), want = whiteOn() && (f === 'fine' || f === 'rolled');
    if (!t.__o) { if (!want) return false; t.__o = t.img; }
    var tgt = want ? pad(t.__o) : t.__o;
    if (t.img === tgt) return false;
    t.img = tgt;
    return true;
  }

  /* optional extra white margin round a cut-out (7% each side); switched off because the floppy cut-out is the full printed area. Set FLOP to the floppy test to bring it back. */
  var FLOP = false;
  function fpad() {
    if (!FLOP) return false;
    var x = window.__fpx;
    if (!x || typeof x.art !== 'function') return false;
    var t = x.art();
    if (!t || !t.img || t.__f) return false;
    var i = t.img, w = i.naturalWidth || i.width, h = i.naturalHeight || i.height, m = Math.round(w * 0.07);
    var k = document.createElement('canvas');
    k.width = w + 2 * m; k.height = h + 2 * m;
    var c = k.getContext('2d');
    c.fillStyle = '#fff';
    c.fillRect(0, 0, k.width, k.height);
    c.drawImage(i, m, m);
    t.img = k;
    t.__f = 1;
    return true;
  }

  function names(v) {
    if (/^borderless/i.test(v)) return ['Borderless', 'Colour runs to the edge'];
    if (/white border/i.test(v)) return ['White border', 'Approx 5mm all round'];
    return [v, ''];
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function pick(el, re) {
    var rs = el.querySelectorAll('input[type=radio]');
    for (var i = 0; i < rs.length; i++) {
      if (re.test(rs[i].value)) {
        if (!rs[i].checked) { var lb = rs[i].id && document.querySelector('label[for="' + rs[i].id + '"]'); (lb || rs[i]).click(); }
        return;
      }
    }
  }
  var lastKey = '';
  function build() {
    var el = borderEl(), panel = document.querySelector('.fp-in-panel');
    if (!el || !panel) return;
    el.classList.add('fps-hide');
    var f = finish(), show = f === 'fine' || f === 'rolled';
    /* Borderless unless the customer has chosen a white border on a fine art print or rolled canvas */
    if (!el.querySelector('input:checked') || (!show && whiteOn())) pick(el, /^borderless/i);
    var box = document.getElementById('fps-bo');
    if (!box) { box = document.createElement('div'); box.id = 'fps-bo'; }
    if (panel.nextSibling !== box) panel.parentNode.insertBefore(box, panel.nextSibling);
    box.hidden = !show;
    var rs = el.querySelectorAll('input[type=radio]'), sig = '', i;
    for (i = 0; i < rs.length; i++) sig += rs[i].value + (rs[i].checked ? '1' : '0') + (document.querySelector('label[for="' + rs[i].id + '"] img') ? 'i' : '');
    var k2 = f + '|' + whiteOn() + '|' + (show ? mmWidth() : '');
    if (k2 !== lastKey) { lastKey = k2; redraw(); }
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    var h = '<p class="fps-lab">Print border</p><div class="fps-row">';
    for (i = 0; i < rs.length; i++) {
      var n = names(rs[i].value), lb = rs[i].id && document.querySelector('label[for="' + rs[i].id + '"] img'), im = lb ? (lb.getAttribute('src') || '').replace(/width=\d+/, 'width=200') : '';
      h += '<button type="button" class="fps-chip' + (rs[i].checked ? ' is-selected' : '') + '" data-i="' + i + '" aria-pressed="' + (rs[i].checked ? 'true' : 'false') + '">' + (im ? '<img class="fps-img" alt="" src="' + esc(im) + '">' : '') + '<span class="fps-t"><span class="fps-name">' + esc(n[0]) + '</span>' + (n[1] ? '<span class="fps-sub">' + esc(n[1]) + '</span>' : '') + '</span></button>';
    }
    box.innerHTML = h + '</div>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#fps-bo .fps-chip');
    if (!b) return;
    var el = borderEl(); if (!el) return;
    var r = el.querySelectorAll('input[type=radio]')[+b.getAttribute('data-i')];
    if (!r) return;
    var lb = r.id && document.querySelector('label[for="' + r.id + '"]');
    (lb || r).click();
    setTimeout(build, 30);
  });

  /* the same border choice inside the enlarged view's Options sheet (after Framing) */
  function zcolour(sh) {
    var rs = document.querySelectorAll('input[name="' + CIN + '"]'), sec = sh.querySelector('.fps-zc'), k = '', i;
    if (MULTI || !rs.length) { if (sec && sec.parentNode) sec.parentNode.removeChild(sec); return; }
    for (i = 0; i < rs.length; i++) k += rs[i].checked ? '1' : '0';
    if (!sec) {
      sec = document.createElement('div');
      sec.className = 'fp-zsec fps-zc';
      sh.insertBefore(sec, sh.querySelector('.fp-zsec'));
    }
    if (sec.getAttribute('data-k') === k) return;
    sec.setAttribute('data-k', k);
    var h = '<p class="fp-zh">' + (/playing-card/.test(location.pathname) ? 'Card style' : /game-board/.test(location.pathname) ? 'Style' : 'Colour') + '</p><div class="fp-zrow">';
    for (i = 0; i < rs.length; i++) h += '<button type="button" class="fp-pill" aria-pressed="' + (rs[i].checked ? 'true' : 'false') + '" data-zcolour="' + i + '">' + esc(rs[i].value) + '</button>';
    sec.innerHTML = h + '</div>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.fps-zc [data-zcolour]');
    if (!b) return;
    var r = document.querySelectorAll('input[name="' + CIN + '"]')[+b.getAttribute('data-zcolour')];
    if (!r) return;
    var lb = r.id && document.querySelector('label[for="' + r.id + '"]');
    (lb || r).click();
    setTimeout(tick, 30);
  });
  function zsheet() {
    var sh = document.querySelector('.fp-zsheet'), el = borderEl(), f = finish();
    if (!sh) return;
    zcolour(sh);
    var sec = sh.querySelector('.fps-zb'), show = !!el && (f === 'fine' || f === 'rolled');
    if (!show) { if (sec && sec.parentNode) sec.parentNode.removeChild(sec); return; }
    var rs = el.querySelectorAll('input[type=radio]'), key = '', i;
    for (i = 0; i < rs.length; i++) key += rs[i].checked ? '1' : '0';
    if (!sec) {
      sec = document.createElement('div');
      sec.className = 'fp-zsec fps-zb';
      var ft = sh.querySelector('[data-ztype]'), fs = ft && ft.closest('.fp-zsec');
      if (fs && fs.nextSibling) sh.insertBefore(sec, fs.nextSibling);
      else sh.insertBefore(sec, sh.querySelector('.fp-zdone'));
    }
    if (sec.getAttribute('data-k') === key) return;
    sec.setAttribute('data-k', key);
    var h = '<p class="fp-zh">Print border</p><div class="fp-zrow">';
    for (i = 0; i < rs.length; i++) h += '<button type="button" class="fp-pill" aria-pressed="' + (rs[i].checked ? 'true' : 'false') + '" data-zborder="' + i + '">' + esc(names(rs[i].value)[0]) + '</button>';
    sec.innerHTML = h + '</div>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.fps-zb [data-zborder]');
    if (!b) return;
    var el = borderEl(); if (!el) return;
    var r = el.querySelectorAll('input[type=radio]')[+b.getAttribute('data-zborder')];
    if (!r) return;
    var lb = r.id && document.querySelector('label[for="' + r.id + '"]');
    (lb || r).click();
    setTimeout(tick, 30);
  });

  function tick() { syncStyle(); build(); zsheet(); var fp = fpad(); if (applyPad() || fp) { redraw(); try { if (window.__fpzoom && window.__fpzoom.redraw) window.__fpzoom.redraw(); } catch (e) { /* ignore */ } } }
  document.addEventListener('change', function () { setTimeout(tick, 60); }, true);
  document.addEventListener('click', function () { setTimeout(tick, 120); }, true);
  document.addEventListener('gpoRenderCompleted', function () { setTimeout(tick, 60); });
  setInterval(function () { try { tick(); } catch (err) { /* ignore */ } }, 300);
})();
